<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="add-new-speciality"
    :visible="isAdd"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @change="(val) => $emit('update:is-add', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ isEdit ? 'Editar' : 'Agregar nueva' }} orden de compra</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="[hide(), resetForm()]" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ invalid }" ref="refFormObserver">
        <!-- Form -->
          <b-form class="p-2" @submit.prevent="onSubmit">
          <!-- Campos para Importación -->
          <div>
            <validation-provider #default="{ errors }" name="enterprise" rules="requeridoE">
            <b-form-group label="Nombre Empresa">
              <b-form-input v-model="items.enterprise" placeholder="Nombre de la empresa" />
               <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
            </validation-provider>

            <validation-provider #default="{ errors }" name="ruc" rules="requeridoE">
            <b-form-group label="RUC Empresa">
              <b-form-input v-model="items.ruc" placeholder="RUC de la empresa" />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
            </validation-provider>
            
            <validation-provider #default="{ errors }" name="supplier" rules="requeridoE">
            <b-form-group label="Proveedor">
              <b-form-input v-model="items.supplier" placeholder="Nombre del proveedor" />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
            </validation-provider>

            <validation-provider #default="{ errors }" name="referralGuide" rules="requeridoE">
            <b-form-group label="Guía de Remisión">
              <b-form-input v-model="items.referralGuide" placeholder="Número de guía de remisión" />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
            </validation-provider>

            <validation-provider #default="{ errors }" name="invoiceNumber" rules="requeridoE">
            <b-form-group label="Número de Factura">
              <b-form-input v-model="items.invoiceNumber" placeholder="Número de factura" />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
            </validation-provider>

            <validation-provider #default="{ errors }" name="dateIssuance" rules="requeridoE">
            <b-form-group label="Fecha de Emisión">
              <b-form-input type="date" v-model="items.dateIssuance" />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
            </validation-provider>

            <validation-provider #default="{ errors }" name="dateReceipt" rules="requeridoE">
            <b-form-group label="Fecha de Recepción">
              <b-form-input type="date" v-model="items.dateReceipt" />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
            </validation-provider>

            <b-form-group label="Tipo de Establecimiento">
              <v-select
                v-model="items.establishmentType"
                :options="typeOptions"
                :reduce="type => type.value"
                label="text"
                placeholder="Seleccionar tipo de establecimiento"
                @input="loadEstablishments"
              />
            </b-form-group>

            <validation-provider #default="{ errors }" name="establishmentId" rules="requeridoE">
            <b-form-group label="Establecimiento">
              <v-select
                v-model="items.establishmentId"
                :options="locals"
                :reduce="local => local.id"
                label="name"
                placeholder="Seleccionar Establecimiento"
              />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
            </validation-provider>
          </div>

          <!-- Form Actions -->
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              :disabled="invalid"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              <b-spinner v-if="isDisabled" small />
              <span v-if="isDisabled" class="px-1">guardando...</span>
              <span v-else>{{ isEdit ? 'Actualizar' : 'Agregar' }}</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="[hide(), resetForm()]"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable*/
import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import StoresService from '@/services/StoresService'
import NationalService from '@/services/NationalService'
import vSelect from 'vue-select'
Vue.use(BootstrapVue)
export default {
  directives: {
    Ripple
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      required,
      isEdit: false,
      isDisabled: false,
      items: {
        enterprise: '',
        ruc: '',
        supplier: '',
        referralGuide: '',
        invoiceNumber: '',
        dateIssuance: '',
        dateReceipt: '',
        establishmentType: '',
        establishmentId: null,
      },
      temp: {},
      typeOptions: [
        { text: 'Tienda', value: 'STORE' },
        { text: 'Almacen', value: 'WAREHOUSE' },
      ],
      locals: [],
    }
  },
  mounted(){
    
  },
  methods: {
    async loadEstablishments() {
        const arrayFilters = [{ keyContains: 'establishmentType', key: 'equals', value: this.items.establishmentType }];
        const url = `?limit=10&page=1&order=desc&sort=id&filter=${JSON.stringify(arrayFilters)}`;

        try {
          const resp = await StoresService.getStores(url, this.$store);
          if (resp && resp.data && resp.data.rows) {
            this.locals = resp.data.rows;
          }
        } catch (error) {
          console.error('Error al cargar los establecimientos:', error);
        }
    },
    getData(items) {
      if (Object.entries(items).length !== 0) {
        this.temp = items;
        this.items = { ...items }; 
        this.isEdit = true;
        this.loadEstablishments()
      } else {
        this.resetForm();
      }
      console.log('temp EN ADD', this.temp)
    },
    resetForm() {
      this.$refs.refFormObserver.reset()
      this.temp = {
        enterprise: '',
        ruc: '',
        supplier: '',
        referralGuide: '',
        invoiceNumber: '',
        dateIssuance: '',
        dateReceipt: '',
        establishmentType: '',
        establishmentId: null,
      }
      this.isEdit = false
      this.items = this.temp
    },
    async onSubmit() {
      console.log('data', this.items)
      this.$refs.refFormObserver.validate().then(async (success) => {
        if (success) {
          this.isDisabled = true
          let resp = ''
          const payload = {
            enterprise: this.items.enterprise,
            ruc: this.items.ruc,
            supplier: this.items.supplier,
            referralGuide: this.items.referralGuide,
            invoiceNumber: this.items.invoiceNumber,
            dateIssuance: new Date(`${this.items.dateIssuance}T00:00:00.000Z`).toISOString(),
            dateReceipt: new Date(`${this.items.dateReceipt}T00:00:00.000Z`).toISOString(),
            establishmentType: this.items.establishmentType,
            establishmentId: this.items.establishmentId,
          };
          console.log('payload', payload)
          if (this.isEdit == false) {
            resp = await NationalService.saveNational(payload, this.$store)
          } else {
            resp = await NationalService.updateNational(this.items.id, payload, this.$store)
          }
          console.log('resp',resp)
          if (resp) {
            this.$swal({
              title: 'Añadido',
              text: 'La orden de compra nacional ha sido ' + (this.isEdit == true ? 'actualizada.' : 'registrada.'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
            console.log('this.$parent.$parent', this.$parent.$parent)
            this.$parent.$parent.$parent.getData()
            this.$emit('update:is-add', false)
            this.resetForm()
          } else {
            this.$swal({
              title: 'Error!',
              text: ' Hubo un error al ' + (this.isEdit == true ? 'actualizar' : 'registrar') + ' la orden de compra nacional',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
          }
          this.isDisabled = false
        } else {
          console.log('no validado')
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
